import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import { ProtectedRoute, RolesTable, SubNavbar, SubNavLink } from '../../components';
import { Can } from '../../providers';
import { Advisors, Churches, Conferences, Districts, EpiscopalAreas, Jurisdictions } from '..';

export function Admin() {
  const { url } = useRouteMatch();

  return (
    <>
      <SubNavbar>
        <SubNavLink to={`${url}/churches`}>Churches</SubNavLink>
        <SubNavLink to={`${url}/districts`}>Districts</SubNavLink>
        <SubNavLink to={`${url}/conferences`}>Conferences</SubNavLink>

        <Can do="update" on="EpiscopalArea">
          <SubNavLink to={`${url}/episcopal-areas`}>Episcopal Areas</SubNavLink>
        </Can>
        <Can do="update" on="Jurisdiction">
          <SubNavLink to={`${url}/jurisdictions`}>Jurisdictions</SubNavLink>
        </Can>
        <SubNavLink to={`${url}/advisors`}>Advisors</SubNavLink>
        <Can do="update" on="Role">
          <SubNavLink to={`${url}/roles`}>Roles</SubNavLink>
        </Can>
      </SubNavbar>

      <Switch>
        <Route exact path={url}>
          <Redirect to={`${url}/conferences`} />
        </Route>

        {/* TODO: Add permission check for church management
            Example: hasPermission={(ability) => ability.can('read', 'Church')} */}
        <ProtectedRoute path={`${url}/churches`}>
          <Churches />
        </ProtectedRoute>

        {/* TODO: Add permission check for district management
            Example: hasPermission={(ability) => ability.can('read', 'District')} */}
        <ProtectedRoute path={`${url}/districts`}>
          <Districts />
        </ProtectedRoute>

        {/* TODO: Add permission check for conference management
            Example: hasPermission={(ability) => ability.can('read', 'Conference')} */}
        <ProtectedRoute path={`${url}/conferences`}>
          <Conferences />
        </ProtectedRoute>

        {/* TODO: Add permission check for episcopal area management
            Example: hasPermission={(ability) => ability.can('update', 'EpiscopalArea')} */}
        <ProtectedRoute path={`${url}/episcopal-areas`}>
          <EpiscopalAreas />
        </ProtectedRoute>

        {/* TODO: Add permission check for jurisdiction management
            Example: hasPermission={(ability) => ability.can('update', 'Jurisdiction')} */}
        <ProtectedRoute path={`${url}/jurisdictions`}>
          <Jurisdictions />
        </ProtectedRoute>

        {/* TODO: Add permission check for advisor management
            Example: hasPermission={(ability) => ability.can('read', 'User')} */}
        <ProtectedRoute path={`${url}/advisors`}>
          <Advisors />
        </ProtectedRoute>

        {/* TODO: Add permission check for role management
            Example: hasPermission={(ability) => ability.can('update', 'Role')} */}
        <ProtectedRoute path={`${url}/roles`}>
          <RolesTable />
        </ProtectedRoute>
      </Switch>
    </>
  );
}

export default Admin;
